export default "__VITE_ASSET__DncFX8Eq__"